import React, { useContext } from 'react';
import { AppSidebar, AppSidebarMenuItem } from '@redpanda/ui';
import {
  PresentationChartBarIcon,
  BookOpenIcon,
  PencilSquareIcon,
  DocumentTextIcon,
  BuildingLibraryIcon,
  ArrowsRightLeftIcon,
  CalendarDaysIcon,
  ChartBarIcon,
  DocumentChartBarIcon,
  CalculatorIcon,
} from '@heroicons/react/24/outline';
import { UserContext } from '../context/UserContext';
import { useTranslation } from 'react-i18next';
import { Language } from '@redpanda/types';
import ThemeSelector from './ThemeSelector';

interface SidebarProps {
  className?: string;
  isMobileOpen?: boolean;
  onCloseMobile?: () => void;
}

const menuItems: AppSidebarMenuItem[] = [
  { path: '/', labelKey: 'navbar.dashboard', icon: PresentationChartBarIcon },
  { path: '/accounts', labelKey: 'navbar.accounts', icon: BookOpenIcon },
  { path: '/journals', labelKey: 'navbar.journals', icon: PencilSquareIcon },
  { path: '/bank-reconciliation', labelKey: 'navbar.bankReconciliation', icon: ArrowsRightLeftIcon },
  { path: '/invoices', labelKey: 'navbar.invoices', icon: DocumentTextIcon },
  { path: '/tax-reports', labelKey: 'navbar.taxReports', icon: CalculatorIcon },
  { path: '/bank-accounts', labelKey: 'navbar.bankAccounts', icon: BuildingLibraryIcon },
  { path: '/reports', labelKey: 'navbar.reports', icon: DocumentChartBarIcon },
  { path: '/period-management', labelKey: 'navbar.periodManagement', icon: CalendarDaysIcon },
  { path: '/period-comparison', labelKey: 'navbar.periodComparison', icon: ChartBarIcon },
];

const Sidebar: React.FC<SidebarProps> = (props) => {
  const { user, logout, updateUserLanguage } = useContext(UserContext)!;
  const { t, i18n } = useTranslation();

  return (
    <AppSidebar
      appName={`RedPanda ${t('app.title')}`}
      menuItems={menuItems}
      user={user}
      currentLanguage={i18n.language}
      onLanguageChange={(lng) => {
        if (updateUserLanguage) updateUserLanguage(lng as Language);
        else i18n.changeLanguage(lng);
      }}
      onLogout={logout}
      themeSelector={<ThemeSelector />}
      currentSystem="ACCOUNTING"
      {...props}
    />
  );
};

export default Sidebar;
